import { useReportMetricsContextV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import TicketGroupReportTableV2 from 'src/tables/TicketGroupReportTable/TicketGroupReportTable';

import { ReportsPageLayout } from '../Reports/ReportsPageLayout';
import * as styles from './ReportsTicketGroupPage.css';

export function ReportsTicketGroupPage() {
  // All the child components treat tempReportConfig as the reportConfig
  // to get its latest state
  const {
    tempReportConfig: reportConfig,
    reportMetrics,
    reportSummary,
    reportValueTypes,
  } = useReportMetricsContextV2();

  return (
    <ReportsPageLayout
      reportConfig={reportConfig}
      reportTable={
        <TicketGroupReportTableV2
          className={styles.table}
          metricsData={reportMetrics}
          summaryData={reportSummary}
          report={reportConfig}
          reportValueTypes={reportValueTypes}
        />
      }
    />
  );
}
